import React from 'react';
import '../../scss/components/ApiCheck.scss';

interface SingleErrorProps {
    error:string,
    message:string
}

interface BoxProps {
    children?:any,
    errors:Record<string, unknown>|undefined|SingleErrorProps
}

const ApiCheck = ({
    children,
    errors
}:BoxProps) => {
    if (typeof errors === 'string') {
        return (
            <div className='api-error'>
                <span>{ errors }</span>
            </div>
        )
    } else {
        return (
            errors && Object.keys(errors).length > 0 ? (
                <div className='api-error'>
                    <span>{ 'message' in errors && typeof errors.message === 'string' ? errors.message : '' }</span>
                </div>
            ) : (
                children ? children : <></>
            )
        )
    }
}

export default ApiCheck;